module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center center\">\n<app-more-info *ngIf=\"additionalInfo\"></app-more-info>\n</div>"